import React from "react";
import Modal from "react-modal";
import Plus from "../../../images/icons/plus-black.svg";
import crssrImage from "../../../images/singleinvoice/cross-red.svg";

/**
 * Bulk Import Modal Component
 * Handles bulk user import via Excel file
 */
const BulkImportModal = ({
  isOpen,
  onRequestClose,
  bulkImportFileName,
  handleBulkImportUpload,
  handleUpload,
  isBulkImportLoading,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={!isBulkImportLoading ? onRequestClose : undefined}
      contentLabel="Bulk Import Users"
      className="bulk-import-popup"
    >
      <div className="modal">
        <div className="outter-modal-main">
          <a
            className="close-image-clr1"
            onClick={onRequestClose}
            disabled={isBulkImportLoading}
            aria-label="Close bulk import modal"
          >
            <img src={crssrImage} alt="Close Bulk Import" />
          </a>
        </div>
        <div className="outter-modal-main">
          <p>Bulk Import</p>
          <form>
            <div className="relative w-full mb-3">
              <label className="gray-label">Select client list</label>
              <div className="file-input-wrapper">
                <input
                  type="text"
                  className="form-input form-input-file"
                  value={bulkImportFileName}
                  readOnly
                  aria-label="Selected file name"
                />
                <input
                  type="file"
                  id="expFileAttchEdit"
                  name="expFileAttchEdit"
                  className="form-input hidden-input"
                  onChange={handleBulkImportUpload}
                  accept=".xlsx"
                  aria-label="Select Excel file"
                />
                <label
                  htmlFor="expFileAttchEdit"
                  className="file-input-label"
                >
                  <img src={Plus} alt="Browse" />
                  Browse
                </label>
              </div>
              <div className="text-sm bulk-text">
                Demo File: {"    "}
                <a
                  href="https://docs.google.com/spreadsheets/d/1rCCZmtrRoUs2wL-58OzTunfEYZdiVRQnvKYrTYQIhoQ/edit?usp=sharing"
                  className="form-textarea"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Import_demo.xlsx
                </a>
              </div>
            </div>

            <div className="bulk-btn-section sprint-btn-outer">
              <button
                className="submit-client cancel-sprint"
                type="button"
                onClick={onRequestClose}
                disabled={isBulkImportLoading}
                aria-label="Close modal"
              >
                Close
              </button>
              <button
                className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded-full shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={handleUpload}
                disabled={isBulkImportLoading}
                aria-label="Upload file"
              >
                {isBulkImportLoading ? (
                  <div
                    style={{
                      width: "80px",
                      height: "18px",
                      backgroundColor: "rgba(255, 255, 255, 0.6)",
                      borderRadius: "4px",
                      animation: "pulse 1.5s ease-in-out infinite",
                      display: "inline-block",
                    }}
                  />
                ) : (
                  "Send"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </Modal>
  );
};

export default BulkImportModal;

